import requestAxios from "@/helpers/request_axios";
import * as MutationsType from "./mutationsType";

export default {
  async getBackupConfig({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/backup",
        method: "GET",
      });

      commit(MutationsType.SET_BACKUP, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async syncBackup({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/backup/sync",
        method: "POST",
      });

      commit(MutationsType.SET_BACKUP, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  resetModuleBackup({ commit }) {
    commit(MutationsType.SET_BACKUP, null);
  },
};
